import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LogOut, Inbox, Users, Briefcase } from 'lucide-react';
import { adminApi, useNoIndex } from './adminApi';

const TABS = [
  { to: '/admin/discovery', label: 'Intake Form', icon: Inbox, id: 'discovery' },
  { to: '/admin/careers', label: 'Career', icon: Users, id: 'careers' },
  { to: '/admin/opportunities', label: 'Opportunity', icon: Briefcase, id: 'opportunities' },
];

export const AdminChrome = ({ title, subtitle, actions, children, testId }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useNoIndex();
  const signOut = async () => { await adminApi.logout(); navigate('/admin/login', { replace: true }); };

  return <div className="admin-shell" data-testid={testId}>
    <header className="admin-topbar">
      <div className="admin-topbar-inner">
        <img src="/brand/techspitze-logo.webp" alt="TechSpitze" data-testid="admin-logo" />
        <div className="admin-title-block">
          <h1 data-testid="admin-heading">{title}</h1>
          <span data-testid="admin-subtitle">{subtitle}</span>
        </div>
        <div className="admin-topbar-actions">
          {actions}
          <button type="button" className="admin-btn admin-btn-ghost admin-hide-sm" onClick={signOut} data-testid="admin-logout"><LogOut size={15} />Log out</button>
        </div>
      </div>
      <nav className="admin-tabs" aria-label="Admin sections">
        {TABS.map(tab => (
          <Link
            key={tab.id}
            to={tab.to}
            className={`admin-tab ${pathname.startsWith(tab.to) ? 'is-on' : ''}`}
            data-testid={`admin-tab-${tab.id}`}
          >
            <tab.icon size={14} />
            {tab.label}
          </Link>
        ))}
        <button type="button" className="admin-tab admin-tab-logout" onClick={signOut} data-testid="admin-tab-logout">
          <LogOut size={14} />
          Log out
        </button>
      </nav>
    </header>
    <div className="admin-body">{children}</div>
  </div>;
};

export const useAdminGuard = () => {
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);
  useEffect(() => {
    let active = true;
    adminApi.me().then(ok => {
      if (!active) return;
      if (ok) setReady(true); else navigate('/admin/login', { replace: true });
    });
    return () => { active = false; };
  }, [navigate]);
  return ready;
};
